<template>
<div id="header-top" class="container-fluid">
    <div v-if="logoutSplash" class="logout-splash">
      <span>{{ logoutMessage }}</span>
    </div>
    <div class="row">
        <div class="header navbar fixed-top navbar-default">
            <div class="bar-logo">
              <!-- Sidebar Toggle -->
              <div class="button" :class="{ cancel: showMobileMenu }" @click="showSidebar">
                <div class="bar top"></div>
                <div class="bar middle"></div>
                <div class="bar bottom"></div>
              </div>

            
              <!-- Logo + LIVE Indicator -->
              <div class="logo-live-wrapper d-flex align-items-center">
                <!-- Logo -->
                <span class="logo" id="logo">
                    <a href="/">
                        <img src="/logo.png" alt="Dayruns" width="70" />
                    </a>
                </span>

                <!-- LIVE Badge -->
               <div class="live-badge"
                  @click="showComingSoon"
                  style="cursor: pointer;"
                >
                  <svg width="50" height="38" viewBox="0 0 92 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <!-- Background with your color D33E74 -->
                    <rect width="92" height="38" rx="6" fill="#D33E74"/>
                    
                    <!-- LIVE Text -->
                    <text 
                      x="13" 
                      y="26" 
                      font-family="Arial Black, sans-serif" 
                      font-size="21" 
                      font-weight="700" 
                      fill="white" 
                      letter-spacing="0.8">
                      LIVE
                    </text>

                    <!-- Signal waves -->
                    <circle cx="69" cy="19" r="3.5" fill="#FF8ABF"/>
                    <path d="M75 11 Q80 19 75 27" stroke="#FF8ABF" stroke-width="3.5" stroke-linecap="round" fill="none"/>
                    <path d="M82 7 Q89 19 82 31" stroke="#FF8ABF" stroke-width="3.5" stroke-linecap="round" fill="none"/>
                  </svg>
                </div>
              </div>
            </div>

            <!-- SEARCH MODELS -->
            <div class="search-wrapper d-flex align-items-center">
              <div
                class="search-box"
                 @click="openSearchModal"
              >
                <i
                  class="fa fa-search search-icon"
                  @click="openSearchModal"
                ></i>

                <input
                  type="text"
                  class="search-input"
                  placeholder="Search by name, location, age..."
                  v-model="search"
                  @click="openSearchModal"
                  readonly
                />
              </div>
            </div>

              <!-- Top Menu (Responsive Dropdown) -->
              <div class="login-container" v-if="userid == null">
                  <router-link to="/register" class="register-menu">
                      <i class="fa fa-user-plus"></i> Join Now
                  </router-link>
                  <router-link to="/login" class="login-menu">
                      <i class="fa fa-sign-in-alt"></i>  Login
                  </router-link>

                  <!-- Mobile ellipsis -->
                  <div class="elipse-mobile-menu mobile-only" @click.stop="toggleMenu">
                    <i class="fas fa-ellipsis-v"></i>

                    <div class="dropdown-menu1" v-if="showMenu">
                      <div class="inner-content">
                        <div class="dropdown-title">
                          <span>Quick menu</span>
                        </div>
                        <router-link to="/register" class="dropdown-item1">
                          <span class="menu-icon"><i class="fa fa-user-plus"></i></span>
                          <span class="menu-text">
                            <strong>Free Account</strong>
                            <small>Create an account in seconds</small>
                          </span>
                        </router-link>
                        <router-link to="/login" class="dropdown-item1">
                          <span class="menu-icon"><i class="fa fa-sign-in-alt"></i></span>
                          <span class="menu-text">
                            <strong>Login</strong>
                            <small>Access your dashboard</small>
                          </span>
                        </router-link>
                        <router-link to="/faq" class="dropdown-item1">
                          <span class="menu-icon"><i class="fa fa-question-circle"></i></span>
                          <span class="menu-text">
                            <strong>FAQ</strong>
                            <small>Find answers fast</small>
                          </span>
                        </router-link>
                        <router-link to="/rooms" class="dropdown-item1">
                          <span class="menu-icon"><i class="fa fa-bed"></i></span>
                          <span class="menu-text">
                            <strong>Rooms</strong>
                            <small>Browse premium rooms</small>
                          </span>
                        </router-link>
                      </div>
                    </div>
                  </div>
              </div>

              <div class="bell-profile dropdown" v-if="userid != null">
                  <span class="bell" @click="openNotifications(listNotifications)">
                    <img v-if="listNotifications.length === 0" src="../../assets/notification-bing.svg" alt="">
                    <img v-else src="../../assets/notification-icon.svg" alt="">
                  </span>
                  <span class="d-flex flex-column dropdown-toggle pl-1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="text-white" style="font-size: 11px; font-weight: 600;"> {{ username }}</span> 
                        <span class="text-white" style="font-size: 11px; font-weight: 600;">{{ formatToken(walletBalance) }}{{ token_label }}</span>
                  </span>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <router-link v-if="user_role === 'escort' || user_role === 'content-creator'" class="dropdown-item" :to="'/profile/' + userid + '/'+ username">My Profile</router-link>
                    <router-link v-if="user_role === 'guest'" class="dropdown-item" :to="'/guest-profile/' + userid + '/'+ username">My Profile</router-link>
                    <div @click="logout" class="dropdown-item text-white logout" > <span>Logout</span> </div>
                  </div>
              </div>
        </div>
        <!-- VIP Notice Bar -->
        <div class="vip-scroll-bar">
          <div class="vip-scroll-text">
            ✨ For exclusive content and premium experiences, visit the 
            <router-link to="/vip-lounge" class="vip-link">VIP Lounge</router-link> 👑
          </div>
        </div>

        <nav class="mobile-nav bg-light shadow-sm py-2 px-3" :class="{ expanded: showMobileMenu }">
            <div class="mobile-menu">
                <a href="/" class="flex-fill nav-link-mobile" title="Home">
                    <i class="fa fa-home"></i>
                    <small class="label">Home</small>
                </a>

                <a href="/#models" class="flex-fill nav-link-mobile" title="Models">
                    <i class="fa fa-female"></i>
                    <small class="label">Models</small>
                </a>

                <a href="/vip-lounge" class="flex-fill nav-link-mobile" title="VIP Lounge">
                    <i class="fa fa-users"></i>
                    <small class="label">VIP Lounge</small>
                </a>

                <a href="/videos" class="flex-fill nav-link-mobile" title="Videos">
                    <i class="fa fa-video"></i>
                    <small class="label">Videos</small>
                </a>

                <a href="/#tour" class="flex-fill nav-link-mobile" title="Tour">
                    <i class="fa fa-bed"></i>
                    <small class="label">Tour</small>
                </a>

                <a href="/rooms" class="flex-fill nav-link-mobile" title="Rooms">
                    <i class="fa fa-bed"></i>
                    <small class="label">Rooms</small>
                </a>

                <a href="/faq" class="flex-fill nav-link-mobile" title="FAQ">
                    <i class="fa fa-question"></i>
                    <small class="label">FAQ</small>
                </a>

                <!-- Categories Header -->
                <div class="nav-link-mobile text-muted mt-3">
                    <i class="fa fa-th-large"></i>
                    <small class="label">Categories</small>
                </div>

                <!-- Model Categories -->
                <a v-for="category in categories" 
                  :key="category.name"
                  :href="category.name === 'vip' ? category.url : '#'"
                  class="flex-fill nav-link-mobile"
                  @click.prevent="handleCategoryClick(category)"
                >
                  <i :class="category.icon"></i>
                  <small class="label">
                    {{ category.label }} 
                    <span class="count">({{ category.count }})</span>
                  </small>
                </a>

                <!-- Age Filters -->
                <a href="/models?search=under23" class="flex-fill nav-link-mobile">
                    <i class="fa fa-angle-down"></i>
                    <small class="label">&lt; 23</small>
                </a>

                <a href="/models?search=23-30" class="flex-fill nav-link-mobile">
                  <i class="fa fa-angle-double-left"></i>
                  <i class="fa fa-angle-double-right ms-1"></i>
                    <small class="label">23 – 30</small>
                </a>

                <a href="/models?search=30-50" class="flex-fill nav-link-mobile">
                    <i class="fa fa-angle-up"></i>
                    <small class="label">30 – 50</small>
                </a>
            </div>
        </nav>
    </div>
    <!-- Notifications Modal -->
    <div class="notification-modal-backdrop" v-if="showNotifications">
      <div class="notification-modal">

        <!-- Header -->
        <div class="modal-header">
          <h5>Notifications</h5>
          <span class="close-btn" @click="closeNotifications">&times;</span>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <div v-if="paginatedNotifications.length === 0" class="empty-state">
            <i class="fa fa-bell-slash"></i>
            <p>No notifications yet</p>
          </div>

          <div
            v-for="(notification, index) in paginatedNotifications"
            :key="index"
            class="notification-item"
          >
            <div class="notification-content">
              <p class="message">{{ notification.description }}</p>
              <small class="time">{{ new Date(notification.created_at).toLocaleString() }}</small>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button
            class="btn btn-light"
            :disabled="currentPage === 1"
            @click="prevPage"
          >
            Previous
          </button>

          <button
            class="btn btn-dark"
            :disabled="endIndex >= listNotifications.length"
            @click="nextPage"
          >
            Next
          </button>
        </div>

      </div>
    </div>

    <div class="row app-wrapper" :class="{ shifted: showMobileMenu }">
        <div class="col-md-0">
        </div>
        <div class="col-md-12">
            <router-view />
        </div>
        <div class="col-md-0">
        </div>
    </div>

    <footer class="footer text-white py-5">
        <div class="row text-md-left align-items-start">
          
          <!-- Logo & Description -->
          <div class="col-md-4 mb-4">
            <router-link to="/">
              <img src="/logo.png" alt="Dayruns" width="120" class="mb-2" />
            </router-link>
            <p class="small">
              Discover premium models, private rooms, and entertainment. Your trusted lifestyle companion.
            </p>
          </div>

          <!-- Categories -->
          <div class="col-md-2 mb-4">
            <h5 class="footer-title">Categories</h5>
            <ul class="list-unstyled">
              <li><router-link to="/escorts" class="footer-link">Models</router-link></li>
              <li><router-link to="/rooms" class="footer-link">Rooms</router-link></li>
              <li><router-link to="/galleries" class="footer-link">Galleries</router-link></li>
              <li><router-link to="/videos" class="footer-link">Videos</router-link></li>
            </ul>
          </div>

          <!-- Support -->
          <div class="col-md-3 mb-4">
            <h5 class="footer-title">Support</h5>
            <ul class="list-unstyled">
              <li><router-link to="/help" class="footer-link">Help Center</router-link></li>
              <li><router-link to="/terms" class="footer-link">Terms of Service</router-link></li>
              <li><router-link to="/privacy" class="footer-link">Privacy Policy</router-link></li>
            </ul>
          </div>

          <!-- Social Media -->
          <div class="col-md-3 mb-4">
            <h5 class="footer-title">Follow Us</h5>
            <div>
              <a href="#" class="footer-social mr-3"><i class="fab fa-facebook-f"></i></a>
              <a href="#" class="footer-social mr-3"><i class="fab fa-twitter"></i></a>
              <a href="#" class="footer-social"><i class="fab fa-instagram"></i></a>
            </div>
          </div>
        </div>

        <!-- Bottom Line -->
        <div class="text-center mt-4 border-top pt-3">
          <small>© {{ new Date().getFullYear() }} Dayruns App. All rights reserved.</small>
        </div>
    </footer>

    <!-- Search Modal -->
    <div class="search-modal-backdrop" v-if="showSearchModal">
      <div class="search-modal">
        <!-- Header -->
        <div class="modal-header">
          <h5>Search</h5>
          <span class="close-btn" @click="closeSearchModal">&times;</span>
        </div>

        <!-- Search Input -->
        <div class="modal-body">
          <div class="search-input-container">
            <i class="fa fa-search search-modal-icon"></i>
            <input
              type="text"
              class="search-modal-input"
              placeholder="Search by name, location, age..."
              v-model="search"
              @keyup.enter="performSearch"
              autofocus
            />
          </div>
          
          <!-- Search Results (optional) -->
          <div v-if="searchResults.length > 0" class="search-results">
            <div
              v-for="(result, index) in searchResults"
              :key="index"
              class="search-result-item"
              @click="selectResult(result)"
            >
              <p>{{ result.name }}</p>
              <small>{{ result.location }}</small>
            </div>
          </div>
          
          <!-- Recent Searches (optional) -->
          <div v-if="recentSearches.length > 0" class="recent-searches">
            <h6>Recent Searches</h6>
            <div
              v-for="(recent, index) in recentSearches"
              :key="index"
              class="recent-search-item"
              @click="useRecentSearch(recent)"
            >
              <span>{{ recent }}</span>
              <i class="fa fa-times" @click.stop="removeRecentSearch(index)"></i>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button class="btn btn-light" @click="closeSearchModal">
            Cancel
          </button>
          <button class="btn btn-dark" @click="performSearch">
            Search
          </button>
        </div>
      </div>
    </div>
</div>    
</template>
<script>
import swal from 'sweetalert2';
import inactivityMixin from '../../mixins/inactivityMixin';
import $ from 'jquery';
import { mapState } from "vuex";

export default {
  mixins: [inactivityMixin],

    data() {
    return {
        showSearchModal: false,
        searchResults: [],
        recentSearches: [],
        myprofile: '',
        user_role: '',
        is_chat: 0,
        userid: '',
        showMobileMenu: false,
        username: '',
        isChat: '',
        logoutSplash: false,
        logoutMessage: "",
        search: "",
        showMenu: false,
        listNotifications: [],
        showNotifications: false,
        currentPage: 1,
        perPage: 5,
        categories: [
        { name: 'vip', url: '/vip-lounge', label: 'VIPs', icon: 'fa fa-star', count: 0 },
        { name: 'female', url: '', label: 'Girls', icon: 'fa fa-female', count: 0 },
        { name: 'male', url: '', label: 'Males', icon: 'fa fa-male', count: 0 },
        { name: 'escort', url: '', label: 'Escort', icon: 'fa fa-heart', count: 0 },
        { name: 'model', url: '', label: 'Models', icon: 'fa fa-users', count: 0 },
        // { name: 'all', label: 'All Users', icon: 'fa fa-users', count: 0 }
      ],
      token_label: process.env.VUE_APP_TOKEN_LABEL
    };
  },
  computed: {
    ...mapState(["walletBalance"]),
    
    startIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    endIndex() {
      return this.currentPage * this.perPage;
    },
    paginatedNotifications() {
      return this.listNotifications.slice(this.startIndex, this.endIndex);
    },
  },

    beforeMount(){
        //this.newMessages();
    },
    mounted() {
      
        this.user_role = localStorage.getItem("role");
        this.userid = localStorage.getItem("userid");
        this.isChat = localStorage.getItem("isChat");
        this.fetchCategoryCounts()
        if (this.userid) {
            this.getNotifications(this.userid)
            this.getWalletbalance(this.userid)
            this.listMyProfile(this.userid);   
        }

        $(document).ready(function() {
        $(window).scroll(function() {
            if ($(this).scrollTop() > 100) {
                $('.header-top').fadeIn();
              document.getElementById('top-header').style.display = 'none'
              
            } else {
                $('.header-top').fadeOut();
                if ($(this).scrollTop() == 0) {
                    document.getElementById('top-header').style.display = 'flex'
                }
            }
          
        });

        $('.header-top').click(function() {
            $('html, body').animate({scrollTop: 0}, 800);
            return false;
            });
        });

        setInterval(() => {
            this.showImage = this.showImage === 2 ? 1 : this.showImage + 1;
        }, 10000); // Toggle images every 3 seconds

    },
    created() {
      this.$store.dispatch("loadWalletBalance")
    },

  methods: {
   showComingSoon() {
      swal.fire({
        title: "Live Streaming",
        text: "Live feature is coming soon! 🔥",
        icon: "info",
        confirmButtonColor: "#D33E74",
        confirmButtonText: "OK"
      });
      
    },    
    closeModal() {
      this.$store.commit("ui/HIDE_VIP_MODAL");
      this.$router.push("/wallet-topup");
    },
    handleCategoryClick(category) {
    // VIP → redirect using router
    if (category.name === 'vip') {
      this.$router.push({
        path: '/vip-lounge',
      });
      return;
    }
    this.filterByCategory(category);
    },

    filterByCategory(category) {

      let query = {};

      switch (category.name) {

        case 'female':
          query.search = 'female';
          break;

        case 'male':
          query.search = 'male';
          break;

        case 'escort':
          query.search = 'escort';
          break;
        case 'model':
          query.search = 'content-creator';
          break;
          
        case 'all':
          query = {}; // no filter
          break;
      }

      // Preserve search if it exists
      if (this.search) {
        query.search = this.search;
      }

      // Push route
      this.$router.push({
        path: '/models',
        query
      });
    },
    openNotifications(data = []) {
    // 1. Filter unread notifications
    const unreadNotifications = data.filter(
      n => n.read_status === 'unread'
    );

    // 2. Loop through and update each notification by ID
    unreadNotifications.forEach(notification => {
      this.updateNotifications(notification.id);
    });

    // 3. Update modal list
    //this.updateNotifications(unreadNotifications);

    // 4. Show modal
    this.showNotifications = true;
  },
  closeNotifications() {
    this.showNotifications = false;
  },
  nextPage() {
    if (this.endIndex < this.listNotifications.length) {
      this.currentPage++;
    }
  },
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    open_vip_lounge(){
      this.$router.push("/lounge")
    },
    showSidebar() {
        this.showMobileMenu = !this.showMobileMenu;
    },
   
    profile() {
        document.getElementById("profile").classList.add('profile-menu');
    },
    
    formatToken(value) {
    const num = Number(value);

    if (!Number.isFinite(num)) {
      return value ?? '0';
    }

    // Keep small values readable, show one decimal for thousands, and cap million-plus at 1m.
    if (num >= 1000000) {
      return '1m';
    }

    if (num >= 1000) {
      const abbreviated = (num / 1000).toFixed(1).replace(/\.0$/, '');
      return `${abbreviated}k`;
    }

    return new Intl.NumberFormat('en-US').format(num);
  },

    formatAmount(value) {
      return new Intl.NumberFormat('en-NG', {
        minimumFractionDigits: 0
      }).format(value);
    },

    async getWalletbalance(userId) {
      try {
        const res = await this.$http.get(`/fetch-wallets-byuser/${userId}`)

        if (res.data.success) {
          this.$store.dispatch(
            "setWalletBalance",
            res.data.data
          )
        }
      } catch (err) {
        if (err.response?.data?.message === "Failed to authenticate token") {
          this.jwtLogout()
        }
      }
    },
    async listMyProfile(userid){
         try{
            const response = await this.$http.post('/list-profile', 
            { user_id: userid},
            {
            headers: { 
                //"x-api-key": `${process.env.VUE_APP_API_KEY}`,
                'Content-Type': 'application/json' 
            }
          }
          )
            this.myprofile = response.data.data;

            if (this.myprofile == '') {
              this.username = '';
            }
            else{
              this.username =  this.myprofile[0].username
            }
           
                      
            }catch (err) {
            console.log(err);
        }
    },

    async newMessages(){
         try{
            const response = await this.$http.get('/new-messages', )
            this.is_chat = response.data.chat_count;
                      
            }catch (err) {
            console.log(err);
        }
    },

    async getNotifications(userId) {
      try {

        const response = await this.$http.get(`/get-notifications/${userId}`, {})
      
        if (response.data.success) {
          this.listNotifications = response.data.data
        }
        
        } catch (err) { 
            if (err.response.data.message == "Failed to authenticate token") {
              this.jwtLogout()
            }
            alert(err.response ? err.response.data.message : err.message)
        }
    },

    async updateNotifications(Id) {
      try {

        const response = await this.$http.get(`/close-notifications/${Id}`, {})
      
        if (response.data.success) {
          //
        }
        
        } catch (err) { 
            if (err.response.data.message == "Failed to authenticate token") {
              this.jwtLogout()
            }
            alert(err.response ? err.response.data.message : err.message)
        }
    },
    
    async logout() {
        const confirmLogout = confirm("You are about to log out. Are you sure?");
        if (confirmLogout) {
          try {
            this.response = await this.$http.post('/logout');

            // Set splash message
            this.logoutMessage = this.response.data.message || "Logged out successfully!";
            this.logoutSplash = true;

            // Clear local storage
            localStorage.removeItem("userid");
            localStorage.removeItem("role");
            localStorage.removeItem("email");
            localStorage.removeItem("isChat");
            localStorage.removeItem("wertyuiojhdfghhdrtfyguh")
            localStorage.removeItem("user_balance")
            localStorage.removeItem("name")
            this.$store.commit("SET_WALLET_BALANCE", 0)

            // Wait before redirecting
            setTimeout(() => {
              this.logoutSplash = false;
               window.location.href = '/';
            }, 2500); // splash visible for 2.5 seconds
          } catch (err) {
            console.error("Logout failed:", err);
          }
        }
    },

    async jwtLogout() {
        
          try {
            this.response = await this.$http.post('/logout');

            // Set splash message
            this.logoutMessage = this.response.data.message || "Logged out successfully!";
            this.logoutSplash = true;

            // Clear local storage
            localStorage.removeItem("userid");
            localStorage.removeItem("role");
            localStorage.removeItem("email");
            localStorage.removeItem("isChat");
            localStorage.removeItem("wertyuiojhdfghhdrtfyguh")
            localStorage.removeItem("user_balance")
            localStorage.removeItem("name")
            this.$store.commit("SET_WALLET_BALANCE", 0)

            // Wait before redirecting
            setTimeout(() => {
              this.logoutSplash = false;
               window.location.href = '/';
            }, 2500); // splash visible for 2.5 seconds
          } catch (err) {
            console.error("Logout failed:", err);
          }
        
    },

    async fetchCategoryCounts() {
      try {
        const res = await this.$http.get('/category-counts');
        if (res.data.success) {
          const counts = res.data.data;
          this.categories = this.categories.map(cat => {
            switch(cat.name) {
              case 'vip': cat.count = counts.vip_count; break;
              case 'female': cat.count = counts.female_count; break;
              case 'male': cat.count = counts.male_count; break;
              case 'escort': cat.count = counts.escort_count; break;
              case 'model': cat.count = counts.model_count; break;
              // case 'all': cat.count = counts.total_count; break;
            }
            return cat;
          });
        }
      } catch(err) {
        console.error(err);
      }
    },
    openSearchModal() {
      this.showSearchModal = true;
      // Load recent searches from localStorage
      const saved = localStorage.getItem('recentSearches');
      if (saved) {
        this.recentSearches = JSON.parse(saved);
      }
    },

    closeSearchModal() {
      this.showSearchModal = false;
    },

    performSearch() {
      if (this.search.trim()) {
        // Add to recent searches
        if (!this.recentSearches.includes(this.search)) {
          this.recentSearches.unshift(this.search);
          // Keep only last 5 searches
          if (this.recentSearches.length > 5) {
            this.recentSearches.pop();
          }
          localStorage.setItem('recentSearches', JSON.stringify(this.recentSearches));
        }
        
        // Close modal and redirect to models page with search query
        this.closeSearchModal();
        this.$router.push(`/models?search=${encodeURIComponent(this.search)}`);
      }
    },

    selectResult(result) {
      this.search = result.name;
      this.performSearch();
    },

    useRecentSearch(searchTerm) {
      this.search = searchTerm;
      this.performSearch();
    },

    removeRecentSearch(index) {
      this.recentSearches.splice(index, 1);
      localStorage.setItem('recentSearches', JSON.stringify(this.recentSearches));
    },

  },
    
}
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans&family=Raleway&display=swap');

.logo-live-wrapper {
  display: flex;
  align-items: center;
}

.live-badge {
  position: relative;
  top: 2px;
}

.live-badge svg {
  filter: drop-shadow(0 3px 8px rgba(211, 62, 116, 0.45));
  transition: transform 0.2s ease;
}

.live-badge svg:hover {
  transform: scale(1.05);
}

/* Gentle pulse animation */
.live-badge svg {
  animation: livePulse 2.2s infinite ease-in-out;
}

@keyframes livePulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.92; }
}

/* Mobile responsiveness */
@media (max-width: 576px) {
  .live-badge img {
    width: 68px;
    height: 30px;
  }
  
  .logo img {
    width: 55px;
  }
}
.search-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
}
.logout{
  cursor:pointer;
  padding-left: 5px !important;
}
.logout:hover{
  color: #333 !important;
}
.search-modal {
  background: #fff;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

.search-input-container {
  display: flex;
  align-items: center;
  background: #f6f6f8;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 20px;
  border: 2px solid transparent;
  transition: border-color 0.2s ease;
  
  &:focus-within {
    border-color: #D33E74;
    background: #fff;
  }
}

.search-modal-icon {
  color: #999;
  font-size: 16px;
  margin-right: 12px;
}

.search-modal-input {
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  font-size: 16px;
  color: #333;
  
  &::placeholder {
    color: #aaa;
  }
}

.search-results {
  margin-top: 20px;
  max-height: 300px;
  overflow-y: auto;
}

.search-result-item {
  padding: 12px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background 0.2s ease;
  
  &:hover {
    background: #f9f9f9;
  }
  
  p {
    margin: 0;
    font-weight: 500;
    color: #333;
  }
  
  small {
    color: #666;
    font-size: 12px;
  }
}

.recent-searches {
  margin-top: 30px;
  
  h6 {
    color: #666;
    font-size: 14px;
    margin-bottom: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
}

.recent-search-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  
  span {
    color: #333;
    font-size: 14px;
    
    &:hover {
      color: #D33E74;
    }
  }
  
  .fa-times {
    color: #999;
    cursor: pointer;
    padding: 4px;
    
    &:hover {
      color: #ff4444;
    }
  }
}

.modal-header {
  padding: 16px 24px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #D33E74;
  color: white;
  
  h5 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }
  
  .close-btn {
    cursor: pointer;
    font-size: 28px;
    line-height: 1;
    opacity: 0.8;
    
    &:hover {
      opacity: 1;
    }
  }
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  
  .btn {
    padding: 8px 20px;
    border-radius: 6px;
    font-weight: 500;
    
    &.btn-dark {
      background: #D33E74;
      border-color: #D33E74;
      
      &:hover {
        background: #c1275e;
        border-color: #c1275e;
      }
    }
    
    &.btn-light {
      color: #666;
      
      &:hover {
        background: #f0f0f0;
      }
    }
  }
}

// Make search input readonly but look normal
.search-input {
  cursor: pointer;
  
  &:focus {
    outline: none;
    box-shadow: none;
  }
}

@media (max-width: 768px) {
  .search-modal {
    width: 95%;
    max-height: 85vh;
    border-radius: 8px;
  }
  
  .modal-header {
    padding: 14px 20px;
  }
  
  .modal-body {
    padding: 20px;
  }
  
  .modal-footer {
    padding: 14px 20px;
  }
}
.notification-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-modal {
  background: #fff;
  width: 330px;
  max-height: 80vh;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
}

.modal-header {
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h5 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.close-btn {
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
}

.modal-body {
  padding: 10px 16px;
  overflow-y: auto;
  flex: 1;
}

.notification-item {
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 8px;
  background: #d33e75f1;
}

.notification-item:hover {
  background: #d33e7538;
}

.notification-content .message {
  margin: 0;
  font-size: 14px;
}

.notification-content .time {
  font-size: 11px;
  color: #fff;
}

.modal-footer {
  padding: 10px 16px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-between;
}

.empty-state {
  text-align: center;
  color: #888;
  padding: 30px 10px;
}

.empty-state i {
  font-size: 30px;
  margin-bottom: 10px;
}

.vip-scroll-bar {
  position: fixed;
  top: 70px; /* adjust to match your header height */
  width: 100%;
  background: linear-gradient(90deg, #111, #222);
  color: #fff;
  overflow: hidden;
  z-index: 999;
  height: 35px;
  display: flex;
  align-items: center;
  padding: 0px;
}

.vip-scroll-text {
  white-space: nowrap;
  display: inline-block;
  padding-left: 100%;
  animation: vip-scroll 40s linear infinite;
  font-size: 13px;
  font-weight: 500;
}

.vip-link {
  color: gold;
  font-weight: 600;
  margin: 0 5px;
  text-decoration: none;
}

.vip-link:hover {
  text-decoration: underline;
}

@keyframes vip-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

.text-muted{
  color: #333 !important;
}
.count {
    font-size: 12px;
    opacity: 0.7;
    margin-left: 4px;
}

.login-container {
  position: relative;
}
.elipse-mobile-menu {
 margin-left: 15px;
 cursor: pointer;
 position: relative;
 width: 10px;
 height: 20px;
 border-radius: 50%;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 background: rgba(255, 255, 255, 0.06);
 border: 1px solid rgba(255, 255, 255, 0.08);
 box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
 transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;

 &:hover {
   transform: translateY(-1px);
   background: rgba(255, 255, 255, 0.1);
   border-color: rgba(255, 255, 255, 0.16);
 }

 .fa-ellipsis-v{
   font-size: 20px;
   font-weight: 300;
   color: #fff;
 }
}

/* Visibility control */
.desktop-only {
  display: inline-flex;
}

.mobile-only {
  display: none;
}

/* Dropdown */
.dropdown-menu1 {
  position: absolute;
  right: 0;
  top: calc(100% + 12px);
  background: rgba(16, 12, 20, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);
  min-width: 240px;
  z-index: 1000;
  padding: 10px;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  animation: menuDrop 0.18s ease-out;
}

.inner-content {
  display: flex;
  flex-direction: column;
  padding: 0;
  background: transparent;
  gap: 8px;
}

.dropdown-title {
  padding: 4px 8px 10px;
  color: rgba(255, 255, 255, 0.55);
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.dropdown-item1 {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  font-size: 13px;
  color: #fff;
  text-decoration: none;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;
}

.dropdown-item1:hover {
  background: rgba(211, 62, 116, 0.12);
  border-color: rgba(211, 62, 116, 0.22);
  transform: translateX(2px);
  color: #fff;
}

.menu-icon {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.22), rgba(255, 138, 0, 0.18));
  color: #fff;
}

.menu-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.menu-text strong {
  font-size: 13px;
  font-weight: 700;
  color: #fff;
}

.menu-text small {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.62);
  margin-top: 2px;
}

@keyframes menuDrop {
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Mobile view */
@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: block;
  }
}

.logout-splash {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  font-family: 'Raleway';
  font-style: normal;
  background-color: #0A070F; /* green success */
  color: white;
  padding: 15px;
  text-align: center;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 2px 5px rgba(0,0,0,0.3);
  transition: top 0.3s ease-in-out;
}
/* Cancel icon animation */
.button.cancel .top {
  transform: rotate(45deg) translate(5px, 10px);
}

.button.cancel .middle {
  opacity: 0;
}

.button.cancel .bottom {
  transform: rotate(-45deg) translate(5px, -10px);
}

.search-wrapper {
  position: relative;
}

.search-box {
  position: relative;
  display: flex;
  align-items: center;
  width: 310px;
  min-height: 48px;
  padding: 8px 10px 8px 12px;
  border-radius: 999px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.08));
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease;
  cursor: pointer;
  overflow: hidden;
}

.search-box:focus-within {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.22), rgba(255, 255, 255, 0.12));
  border-color: rgba(255, 255, 255, 0.35);
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.24), 0 0 0 3px rgba(211, 62, 116, 0.18);
  transform: translateY(-1px);
}

.search-icon {
  font-size: 15px;
  color: #fff;
  cursor: pointer;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
 // background: linear-gradient(135deg, #d33e74, #ff8a00);
  box-shadow: 0 10px 18px rgba(211, 62, 116, 0.25);
  flex: 0 0 34px;
}

.search-input {
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  margin-left: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
}

.search-input::placeholder {
  color: rgba(255, 255, 255, 0.72);
  font-weight: 400;
}

@media (max-width: 768px) {
  .search-box {
    width: 38px;
    min-height: 46px;
    padding: 0;
    justify-content: center;
  }

  .search-box.open {
    width: min(72vw, 240px);
    justify-content: flex-start;
    padding: 8px 12px 8px 10px;
  }

  .search-input {
    opacity: 0;
    width: 0;
    margin-left: 0;
    transition: opacity 0.15s ease, width 0.25s ease;
  }

  .search-box.open .search-input {
    opacity: 1;
    width: 100%;
    margin-left: 8px;
  }
}

.mobile-nav {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 70px; /* adjust if header height differs */
  left: 0;
  right: 0;
  z-index: 9999;
  width: 40px; 
  min-height: 100vh;
  background: #0A070F !important;
}

.mobile-nav .nav-link-mobile {
  font-size: 12px;
  padding: 0px;
}

.mobile-nav i {
  font-size: 18px;
}

.mobile-nav.expanded {
  width: 180px;              /* expanded */
}

.label {
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.15s ease;
}

/* Show text only when expanded */
.mobile-nav.expanded .label {
  opacity: 1;
}

.mobile-menu{
    //padding: 0px 5px 0px 10px;
    background: #0A070F;
    margin: 0px;
    font-size: 14px;

    a{
      text-decoration: none;
    }
}
.app-wrapper {
  transition: margin-left 0.25s ease;
  margin-left: 40px;   /* collapsed width */
}

/* Expanded */
@media (min-width: 992px) {
  .app-wrapper.shifted {
    margin-left: 180px;
  }
}

@media (max-width: 991px) {
  .mobile-nav {
    width: 260px;
    transform: translateX(-100%);
  }

  .mobile-nav.expanded {
    transform: translateX(0);
  }

  .app-wrapper {
    margin-left: 0 !important;
  }
}

.nav-link-mobile{
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    margin: 20px 0px;
    font-size: 14px;
    color: #FFF;
    gap: 10px;
    font-weight: bold;

    .fa-female{
      font-size: 20px;
    }
}

.nav-link-mobile a:hover{
    color: #D33E74 !important;
}
.nav-link-mobile small{
    font-size: 12px !important;
    font-weight: bold;
}
.register-menu{
    margin: 0 6px;
    color: #0A070F;
    text-decoration: none;
    border: 1px solid rgba(255, 255, 255, 0.25);
    padding: 0.58rem 1rem;
    border-radius: 999px;
    background: linear-gradient(135deg, #ffffff 0%, #f4f1f6 100%);
    font-weight: 700;
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
    transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}
.register-menu:hover {
    color: #D33E74;
    transform: translateY(-1px);
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.22);
}

.login-menu{
    margin: 0 4px;
    color: #FFFFFF;
    text-decoration: none;
    border: 1px solid rgba(255, 255, 255, 0.4);
    padding: 0.58rem 1rem;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    font-weight: 700;
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;
}
.login-menu:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.14);
    border-color: rgba(255, 255, 255, 0.65);
    transform: translateY(-1px);
}
@media screen and (max-width: 768px){
  .login-menu{
      display: none;
  }
  .register-menu{
      padding: 0.5rem 0.85rem;
      font-size: 12px;
  }
}
.nav-link {
    margin: 0 15px;
    color: #FFFFFF;
    text-decoration: none;
}
.nav-link:hover {
    color: #0A070F;
}
.gap-4 {
    gap: 1.5rem;
}


h2 {
    color: #FFF;
}
.main {
    background: #0A070F;
    width: 100%;
    min-height: 100vh;
}
.space{
    padding: 10px 10px 0px 30px;
}
.container {
    padding: 10px 10px 10px 50px;
    background: transparent;
}
.container-fluid{
    width: 100%;
    min-height: 100vh;
    background: #0A070F;
          .bar-logo{
            display: flex;
            flex-direction: row;
            justify-content: left;
            align-items: center;
          }
          .bar {
            display: block;
            height: 3px;
            width: 30px;
            background-color: #FFF;
            margin: 7px auto;
          }
          .button {
            cursor: pointer;
            display: inline-block;
            width: auto;
            margin: 0 auto;
            -webkit-transition: all .7s ease;
            -moz-transition: all .7s ease;
            -ms-transition: all .7s ease;
            -o-transition: all .7s ease;
            transition: all .7s ease;
            margin-left: 0px;
            color: #FFF;

          }
          .btn-close{
            margin-left: 25px;
            margin-top: -20px;

            .close{
                width: 42px;
                height: 40px;
            }
          }
          .bar {
            -webkit-transition: all .7s ease;
            -moz-transition: all .7s ease;
            -ms-transition: all .7s ease;
            -o-transition: all .7s ease;
            transition: all .7s ease;
          }
    .window-close{
        display: none
    }

    @media screen and (max-width: 768px){
       
        .bar {
            display: block;
            width: 30px;
            background-color: #FFF;
            margin: 7px auto;
          }
          .button {
            cursor: pointer;
            display: inline-block;
            width: auto;
            margin: 0 auto;
            -webkit-transition: all .7s ease;
            -moz-transition: all .7s ease;
            -ms-transition: all .7s ease;
            -o-transition: all .7s ease;
            transition: all .7s ease;
            margin-left: 0px;
            color: #FFF;

          }
          .btn-close{
            margin-left: 25px;
            margin-top: -20px;

            .close{
                width: 42px;
                height: 40px;
            }
          }
          .bar {
            -webkit-transition: all .7s ease;
            -moz-transition: all .7s ease;
            -ms-transition: all .7s ease;
            -o-transition: all .7s ease;
            transition: all .7s ease;
          }
        .sidebar {
            height: 100vh;
            padding: 4rem 1rem;
        }

        .login-register:hover {
            color: #D33E74;
        }

    }

    .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0px 20px 0px 20px;
        height: 70px;
        background: #D33E74;
        width: 100%;   
        font-size: 13px;   
        font-weight: 400; 
    
        .logo > img{
            width: 120px;
            height: 30px;
        }
        .login-container{
            display: flex;
            justify-content: right;
            align-items: center;
        }
        .bell-profile {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            .bell {
                padding: 2px;
                border-radius: 44px;
                background: #fff;
                cursor: pointer;
            }
            img{
              width: 100%;
            }
        }
        .dropdown-menu {
            background: #333;
            color:#ccc; 
            font-size: 16px;
            padding: 0;
        }
        .dropdown-menu > a {
            border-bottom: 0.5px solid #333;
            color:#fff; 
            padding: 5px;
        }
        .dropdown-menu > a:hover {
            color:#000; 
        }
        .dropdown-menu:hover {
            color:#0A070F; 
        }
      
        .profile{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: auto;
            height: 35px;
            background: #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 28px;
            color: #FFFFFF;
            margin-top: -8px;
        }
     }

     @media screen and (max-width: 768px) {
        .header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0px 20px 0px 20px;
            height: 70px;
            background: #D33E74;
            width: 100%;       
        
            .logo > img{
                width: 120px;
                height: 30px;
            }
            .bell-profile {
                display: flex;
                align-items: center;
               // margin: 4px;
    
                .bell {
                    margin: 10px;
                }
                .fa-bell {
                    color:#fff; 
                }
    
            }
            .dropdown-menu {
                background: #0A070F;
                color:#ccc; 
            }
            .dropdown-menu > a {
                background: #312F33;
                color:#ccc; 
            }
            .dropdown-menu:hover {
                //background: #ccc;
                color:#0A070F; 
            }
          
            .profile{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                width: auto;
                height: 35px;
                background: #D33E74;
                border-radius: 82px;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 600;
                font-size: 12px;
                line-height: 28px;
                color: #FFFFFF;
                margin-top: -8px;
                
    
            }
         }
        .sidebar {
            display:none;
        }
        .sidebar {
            height: 100vh;
            padding: 4rem 1rem;
            //margin-right: 100px;
        }
        .mobile-menu{
          margin-top: 0px;
        }
        .mobile-menu.text-dark:hover{
            color: #D33E74 !important;
        }
        .text-dark:hover{
            color: #D33E74 !important;
        }
        .mobile-nav:hover{
            color: #D33E74 !important;
        }
    }
     
     .sidebar {
        height: 100vh;
        padding: 4rem 1rem;
        margin-right: 100px;
    }
      .sidebar a {
        display: block;
        color: white;
        padding: 16px;
        text-decoration: none;
      }
       
      .sidebar a.active {
        background-color: #0A070F;
        color: white;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0px;
        width: 50px;
        height: 50px;
        background: #312F33;
        border-radius: 47px;
        margin: 20px;
      }
      .sidebar a:hover{
        background-color: #D33E74;
      }
      .profile-menu{
        background-color: #D33E74;
      }
     
      .hangout a:hover {
        background-color: #FFFFFF !important;
      }
      .game a:hover {
        background-color: #FFFFFF !important;
      }
      
      @media screen and (max-width: 700px) {
        .sidebar {
          width: auto;
          height: auto;
          position: fixed;
          z-index: 9998;
          transition: opacity .4s ease;
          background-color: rgba(0, 0, 0, .5);
          .window-close{
            display: block;
            color: #FFF;
            margin-left: 35px;
          }
        }
        .sidebar a {float: left;}
        div.content {margin-left: 0;}
      }
      
      @media screen and (max-width: 400px) {
        .sidebar a {
          text-align: center;
          float: none;
        }
      }

}

@media screen and (max-width: 768px) { 
    .container-fluid{
        width: 100%;
        min-height: 100vh;
        background: #0A070F;
        padding-left: -0px;
    }
    .main{
        background: #0A070F;
        width: 100%;
        height: 100vh;    
    }
}
.footer{
    text-align: center;
    padding: 0 30px 0 30px;
    background: #0A070F;
}
.footer-title{
  font-size: 18px;
}
.footer-link{
  color: #D33E74;
  font-size: 12px;
}
.footer-social{
  color: #D33E74;
}
.footer a {
  text-decoration: none;
  transition: color 0.2s ease-in-out;
}
.footer a:hover {
  color: #ff66a6;
}

@media screen and (max-width: 768px) { 
.footer{
    text-align: left;
    padding: 0 0 0 20px;
  
}
}

.modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 580px;
      height: 505px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      background: url(../../assets/modal_bg.png) no-repeat fixed center, #0A070F;
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
    h2 {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    .welcome {
        margin-top: 8px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    label {
        text-align: left;
        color: #fff;
        font-size: 12px;
        margin-left:15px;
        margin-bottom: -6px;
    }
    span {
        margin-bottom: 20px;
    }

  }
  
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
  }
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
  .modal-window {
    & > div {
        border-radius: 63px;
    }
  }
  .modal-logo {
    text-align: center;
    margin-top: -10px;
  }
  .modal-logo > img {
    width: 100px;
    
}
h2 {
   
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 10px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
    line-height: 190%;
    margin-top: 0px;

}
.modal-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 52px;
    width: 380px;
    height: 50px;
    background: #FFFFFF;
    border-radius: 50px;
    margin: 2%;
    cursor: pointer;
}
.login-modal-box {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 52px;
    gap: 311px;
    width: 496px;
    height: 45px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    margin: 10px;
    color: #767475;
}
.btn-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    gap: 10px;
    background: #D33E74;
    border-radius: 82px;
    margin-top: 8px;
    color: #fff;
    margin-left: 10px;
    
}

.header-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  background: #D33E74;
  color: #fff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: visibility 0.5s, opacity 0.5s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.header-top i {
  font-size: 18px;
  color: #fff;
}

.header-top:hover {
  background: #c1275e;
}


</style>
